import React, { createContext, useReducer, useContext, useEffect } from 'react';
import { fetchLoggedInUser } from '../services/authService';

const AuthContext = createContext();

const authReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {
        ...state,
        isAuthenticated: true,
        token: action.payload.token,
        adminToken: action.payload.adminToken,
        user: action.payload.user,
      };
    case 'LOGOUT':
      return {
        ...state,
        isAuthenticated: false,
        token: null,
        adminToken: null,
        user: null,
      };
    case 'SET_USER':
      return {
        ...state,
        user: action.payload.user,
      };
    case 'SET_ADMIN_TOKEN':
      return {
        ...state,
        adminToken: action.payload.adminToken,
      };
    case 'ADMIN_LOGIN':
      return { ...state, isAdminAuthenticated: true };
    default:
      return state;
  }
};


// ✅ EXPORTED function
export const fetchUserData2 = async (token, dispatch) => {
  if (token) {
    try {
      const userData = await fetchLoggedInUser(token);
      dispatch({ type: 'SET_USER', payload: { user: userData } });
    } catch (error) {
      console.error('Error fetching user data:', error);
      dispatch({ type: 'LOGOUT' });
    }
  }
};


const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, {
    isAuthenticated: false,
    token: localStorage.getItem('authToken') || null,
    adminToken: localStorage.getItem('adminUsrtoken') || null,
    user: null,
  });

  useEffect(() => {
    const fetchData = async (token) => {
      if (token) {
        try {
          const userData = await fetchLoggedInUser(token);
          dispatch({ type: 'SET_USER', payload: { user: userData } });
        } catch (error) {
          console.error('Error fetching user data:', error);
          dispatch({ type: 'LOGOUT' });
        }
      }
    };

    const adminuserToken = localStorage.getItem('adminUsrtoken');
    const token = adminuserToken ? adminuserToken : localStorage.getItem('authToken');

    if (token) {
      dispatch({ type: 'LOGIN', payload: { token } });

      fetchData(token);
    } else {
      dispatch({ type: 'LOGOUT' });
    }
  }, [dispatch]);

  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };
